var aklforever = aklforever || {};

aklforever.nav = (function () {
  function init(){
    initNavMenu();
    initNavCloseOutFocus();
  }

  function initNavCloseOutFocus(){
    var nav = document.querySelector('.priority-nav').closest('.container-fluid');
    var navBtn = nav.querySelector('button');
    var hamburger = navBtn.querySelector('.hamburger');
    var outFocus = (function(event){
      if(!nav.contains(event.target)  && hamburger.classList.contains('open')){
        navBtn.click();
      }
    });

    window.addEventListener('click',outFocus);
    window.addEventListener('focusin',outFocus);
  }

  function initNavMenu() {
    var $nav = $(".priority-nav");
    var $btn = $(".priority-nav button");
    var $vlinks = $(".priority-nav .visible-links");
    var $hlinks = $(".priority-nav .hidden-links");

    var breaks = [];

    function updateNav() {
      var availableSpace = $btn.hasClass("hidden")
        ? $nav.width()
        : $nav.width() - $btn.width() - 30;

      // The visible list is overflowing the nav
      if ($vlinks.width() > availableSpace) {
        // Record the width of the list
        breaks.push($vlinks.width());

        // Move item to the hidden list
        $vlinks.children().last().prependTo($hlinks);

        // Show the dropdown btn
        if ($btn.hasClass("hidden")) {
          $btn.removeClass("hidden");
        }

        // The visible list is not overflowing
      } else {
        // There is space for another item in the nav
        if (availableSpace > breaks[breaks.length - 1]) {
          // Move the item to the visible list
          $hlinks.children().first().appendTo($vlinks);
          breaks.pop();
        }

        // Hide the dropdown btn if hidden list is empty
        if (breaks.length < 1) {
          $btn.addClass("hidden");
          if($btn.find('.hamburger').hasClass("open")){
            $btn.find('.hamburger').toggleClass("open");
          }
          $hlinks.addClass("hidden");
        }
      }

      // Recur if the visible list is still overflowing the nav
      if ($vlinks.width() > availableSpace) {
        updateNav();
      }
    }

    // Window listeners

    $(window).on("resize", function () {
      updateNav();
    });

    $btn.on("click", function () {
      $hlinks.toggleClass("hidden");
      $btn.find('.hamburger').toggleClass("open");
      if($btn.attr('aria-expanded') == "true"){
        $btn.attr('aria-expanded',"false");
        // $btn.find('.icon').attr('title',"Open");
      }else{
        $btn.attr('aria-expanded',"true");
        // $btn.find('.icon').attr('title',"Close");
      }
    });

    updateNav();
  }

  return {
    init: init,
  };
})();

aklforever.animate = (function () {
  // percentage from screen height in decimal
  // var animationRate = 1.2; 

  function initAnimations(){
    initFadeIn();
    initFillIn();
  }

  function initFadeIn() {
    var contentBlocks = document.querySelectorAll(
      '[data-animate="fade-in"] .column, .column div[data-animate="fade-in"]'
    );

    contentBlocks = Array.from(contentBlocks)
    .map(function(elem){
      return elem.closest('.column');
    });

    contentBlocks = contentBlocks.filter(function(elem){
      if(elem.querySelectorAll('.modal').length > 0){
        elem.closest('.column').classList.add("component-visible");
        return false;
      }else{
        elem.closest('.column').classList.add("animated");
        return true;
      }
    });

    window.addEventListener("scroll", function () {
      fadeIn();
    });

    function fadeIn() {
      for (var i = 0; i < contentBlocks.length; i++) {
        var elem = contentBlocks[i];
        var distInView = elem.getBoundingClientRect().top - (window.innerHeight +20);
        if (distInView < 0) {
          elem.classList.add("component-visible");
        } else{
          elem.classList.remove("component-visible");
        }
      }
    }

    fadeIn();
  }

  function initFillIn() {
    var contentBlocks = document.querySelectorAll(
      '[data-animate="fill-up"] .fill-in-text'
    );

    contentBlocks.forEach(function(elem){
      elem.dataset.text = elem.innerText || elem.innerHTML;
    });

    window.addEventListener("scroll", function () {
      fillIn();
    });

    function fillIn() {
      for (var i = 0; i < contentBlocks.length; i++) {
        var elem = contentBlocks[i];
        var distInView = elem.getBoundingClientRect().top - (window.innerHeight +20);
        if (distInView < 0) {
          elem.classList.add('filled')
        } else {
          elem.classList.remove('filled')
        }
      }
    }

    fillIn();
  }

  return {
    init: initAnimations,
  };
})();

aklforever.modalmedia = (function(){
  function initMedia(){
    var modals = document.querySelectorAll('.modal');
    modals.forEach(function(elem){
      // init iframes
      elem.querySelectorAll('iframe').forEach(function(item){
        item.title = elem.dataset.videotitle || item.title;
      });

      // add modal event listener
      elem.addEventListener('hidden.bs.modal',function(){
        elem.querySelectorAll('iframe').forEach(function(item){
          item.src = item.src;
        });
        elem.querySelectorAll('video').forEach(function(item){
          item.pause();
        });
      });
    });
  }
  
  return {
    init: initMedia
  };
})();

aklforever.linetracker = (function(){
  function init(){
    if(document.querySelector('.line-tracker-wrapper') == null) return;
    window.addEventListener("resize",function(){ realignTracker(); });
    window.addEventListener("scroll",function(){ realignArrow(); });
    alignTracker();
  }

  function alignTracker(){
    var lineTracker = document.querySelector('.line-tracker-wrapper');
    var arrow = document.querySelector('.line-tracker-arrow');
    var reference = document.querySelector('h1'); // breadcrumb-wrapper hero-image
    var topTarget = 0;
    if(window.innerWidth >= 1024){
      topTarget = -18;
    }
    if(document.querySelector('.breadcrumb-wrapper') !== null){
      if(document.querySelector('h1').previousElementSibling !== null && document.querySelector('h1').previousElementSibling.classList.contains('heading-te-reo')){
        reference = document.querySelector('.heading-te-reo');
      }
    }else{
      if(document.querySelector('.hero-image') !== null){
        if(document.querySelector('h1').previousElementSibling !== null && document.querySelector('h1').previousElementSibling.classList.contains('heading-te-reo')){
          reference = document.querySelector('.heading-te-reo');
        }
        if(window.innerWidth >= 1024){
          topTarget = 200;
        }else{
          topTarget = 104;
        }
      }else{
        if(document.querySelector('h1').previousElementSibling !== null && document.querySelector('h1').previousElementSibling.classList.contains('heading-te-reo')){
          reference = document.querySelector('.heading-te-reo');
        }
      }
    }
    var rect = reference.getBoundingClientRect();
    var leftTarget = 40;
    if(window.innerWidth >= 1024){
      leftTarget = 80;
    }else if(window.innerWidth >= 768){
      leftTarget = 70;
    }else if(window.innerWidth >= 576){
      leftTarget = 60;
    }
    lineTracker.style.left = Math.round(rect.left) - leftTarget + "px";
    lineTracker.style.top = Math.round(rect.top + document.documentElement.scrollTop) - topTarget + "px";
    arrow.style.top = "0px";
    lineTracker.style.display = "block";
  }

  function realignTracker(){
    var lineTracker = document.querySelector('.line-tracker-wrapper');
    // if breadcrumb exist > if te reo exist / h1 exist // if no breadcrumb + hero image exist
    var reference = document.querySelector('h1'); // breadcrumb-wrapper hero-image
    var topTarget = 0;
    if(window.innerWidth >= 1024){
      topTarget = -18;
    }
    if(document.querySelector('.breadcrumb-wrapper') !== null){
      if(document.querySelector('h1').previousElementSibling !== null && document.querySelector('h1').previousElementSibling.classList.contains('heading-te-reo')){
        reference = document.querySelector('.heading-te-reo');
      }
    }else{
      if(document.querySelector('.hero-image') !== null){
        if(document.querySelector('h1').previousElementSibling !== null && document.querySelector('h1').previousElementSibling.classList.contains('heading-te-reo')){
          reference = document.querySelector('.heading-te-reo');
        }
        if(window.innerWidth >= 1024){
          topTarget = 200;
        }else{
          topTarget = 104;
        }
      }else{
        if(document.querySelector('h1').previousElementSibling !== null && document.querySelector('h1').previousElementSibling.classList.contains('heading-te-reo')){
          reference = document.querySelector('.heading-te-reo');
        }
      }
    }
    var rect = reference.getBoundingClientRect();
    var leftTarget = 40;
    if(window.innerWidth >= 1024){
      leftTarget = 80;
    }else if(window.innerWidth >= 768){
      leftTarget = 70;
    }else if(window.innerWidth >= 576){
      leftTarget = 60;
    }
    lineTracker.style.left = Math.round(rect.left) - leftTarget + "px";
    lineTracker.style.top = Math.round(rect.top + document.documentElement.scrollTop) - topTarget + "px";
  }

  function realignArrow(){
    var offset = 200;
    var arrow = document.querySelector('.line-tracker-arrow');
    var lineTracker = document.querySelector('.line-tracker-wrapper');
    var rect = arrow.getBoundingClientRect();
    var arrowPosition = lineTracker.getBoundingClientRect().top + document.documentElement.scrollTop - offset;
    if(Math.round(rect.top) <= offset && document.documentElement.scrollTop > arrowPosition){
      arrow.style.position = "fixed";
      arrow.style.top = "200px";
    }else{
      arrow.style.position = "absolute";
      arrow.style.top = "0px";
    }
  }

  return {
    init:init
  };
})();

aklforever.lottie = (function(){
  function init(){
    setUpLottieComponents();
  }

  function setUpLottieComponents(){
    var lottieElem = document.querySelectorAll('.lottie-animation');
    lottieElem.forEach(function(elem){
      lottie.loadAnimation({
        container: elem, // the dom element that will contain the animation
        renderer: 'svg',
        loop: elem.dataset.loop == "true",
        autoplay: true,
        rendererSettings: {
            title: elem.dataset.title,
            description: elem.dataset.description,
        },
        path: elem.dataset.src // the path to the animation json
      });
    });
  }

  return {
    init:init
  }
})();

aklforever.cookiePolicy = (function(){
  function init(){
    var elem = document.querySelector('.cookies-wrapper');
    if(elem == null) return;
    var accept = elem.querySelector('.btn');
    accept.addEventListener("click", function(){
      setCookie("AFAcceptCookie","true",90);
      hideCookiePolicyPrompt();
      return false;
    });
    showHideCookiePolicyPrompt()
  }

  function hideCookiePolicyPrompt(){
    var elem = document.querySelector('.cookies-wrapper');
    elem.style.display = "none";
  }

  function showHideCookiePolicyPrompt(){
    var elem = document.querySelector('.cookies-wrapper');
    if(getCookie("AFAcceptCookie") != "true"){
      elem.style.display = "block";
    }else{
      elem.style.display = "none";
    }
  }

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  return {
    init:init
  }
})();

(function () {
  aklforever.nav.init();
  aklforever.animate.init();
  aklforever.modalmedia.init();
  aklforever.linetracker.init();
  aklforever.lottie.init();
  aklforever.cookiePolicy.init();
})();
